// extracted by mini-css-extract-plugin
module.exports = {"cell":"playerCell_cell__3as7_","playerDesc":"playerCell_playerDesc__dbNbo","playerName":"playerCell_playerName__gXJGW","nameLine":"playerCell_nameLine__fgQpD"};